// 图片加水印
/**
 *
 * @param {String} text 水印文字
 * @param {String} fontSize 字体大小
 * @param {String} fontConfig 字体属性
 * @param {String} imgWidth 图片宽度
 * @param {String} imgHeight 图片高度
 * @param {String} density 水印密度，数值越大越密，如果名字长该值则越小
 */
export async function addWaterMark({
  text = `水印公司名称`,
  fontSize = 30,
  fontConfig = 'microsoft yahei',
  fillStyle = 'rgba(0, 0, 0, 0.1)',
  imgWidth = 1200,
  imgHeight = 1750,
  density = 5,
  fileName = ''
}) {
  const canvas = toCanvas();
  const blob = await watermark(canvas, {
    text,
    fontSize,
    fontConfig,
    fillStyle,
    imgWidth,
    imgHeight,
    density
  });
  const newImg: any = await blobToImg(blob);
  const src = newImg.src;
  const newFile: any = base64ToFile(src, `${fileName}`);
  const newUrl = window.URL.createObjectURL(newFile);

  return { newFile, src, newUrl };
}

// 图片文件转image
function blobToImg(blob) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const img: any = new Image();
      img.addEventListener('load', () => resolve(img));
      img.crossOrigin = 'Anonymous';
      img.src = reader.result;
      img.width = document.body.clientWidth;
    });
    reader.readAsDataURL(blob);
  });
}

// 图片转canvas
function toCanvas() {
  const canvas = document.createElement('canvas');
  canvas.width = 1200;
  canvas.height = 1750;
  return canvas;
}

function base64ToFile(dataurl, filename = 'image.png') {
  if (!dataurl) {
    return '';
  }
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// canvas 添加水印
function watermark(
  canvas,
  { text, fontSize, fontConfig, fillStyle, imgWidth, imgHeight, density }
) {
  return new Promise(resolve => {
    const context = canvas.getContext('2d');
    context.font = `${fontSize}px ${fontConfig}`;
    context.fillStyle = fillStyle;
    context.textAlign = 'left';
    context.textBaseline = 'Middle';
    context.lineWidth = 1;
    //文字坐标

    const maxPx = Math.max(imgWidth, imgHeight);
    const stepPx = Math.floor(maxPx / density);
    const arrayX = [0]; //初始水印位置 canvas坐标 0 0 点
    while (arrayX[arrayX.length - 1] < maxPx / 2) {
      arrayX.push(arrayX[arrayX.length - 1] + stepPx);
    }
    arrayX.push(
      ...arrayX.slice(1, arrayX.length).map(el => {
        return -el;
      })
    );

    for (let i = 0; i < arrayX.length; i++) {
      for (let j = 0; j < arrayX.length; j++) {
        context.save();
        context.translate(imgWidth / 2, imgHeight / 2); ///画布旋转原点 移到 图片中心
        context.rotate(-Math.PI / 5);
        const offsetY = fontSize * 2;
        context.fillText(text, arrayX[i], arrayX[j] + offsetY);
        context.restore();
      }
    }
    canvas.toBlob(blob => resolve(blob));
  });
}
